import React, {useEffect, useRef, useState} from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {Button, Text, Flex, Box} from '@chakra-ui/react'
import {LockIcon} from '../../../components/icons'
import Link from '../../../components/link'
import {useCurrentBasket} from '../../../hooks/use-current-basket'

const CartStickyCta = () => {
    const {data: basket} = useCurrentBasket()
    const ref = useRef()
    const [stuck, setStuck] = useState(false)

    useEffect(() => {
        const cachedRef = ref.current
        const observer = new IntersectionObserver(([e]) => setStuck(e.intersectionRatio < 1), {
            threshold: [1]
        })
        observer.observe(cachedRef)
        return () => observer.unobserve(cachedRef)
    }, [ref])

    return (
        <Box ref={ref} bg="stokkeCore.white" position="sticky" bottom={-1.5} pb={1.5}>
            <Flex direction="column" padding={4} gap={2}>
                <Button
                    as={Link}
                    to="/appcheckout"
                    rightIcon={<LockIcon />}
                    iconSpacing={4}
                    variant="placeOrder"
                    padding={2.5}
                    size="lg"
                    data-testid="proceed-to-checkout-button"
                >
                    <FormattedMessage
                        defaultMessage="Proceed to Checkout"
                        id="cart_cta.link.checkout"
                    />
                </Button>

                <Flex justify="space-between" visibility={!stuck && 'hidden'}>
                    <Text textStyle="Semi Bold Small">
                        <FormattedMessage
                            defaultMessage="Current total"
                            id="cart_sticky_cta.text.current_total"
                        />
                    </Text>
                    <Text textStyle="Semi Bold Small">
                        <FormattedNumber
                            style="currency"
                            currency={basket?.currency}
                            value={basket?.orderTotal || basket?.productTotal}
                        />
                    </Text>
                </Flex>
            </Flex>
        </Box>
    )
}

export default CartStickyCta
